import {Component, OnInit} from '@angular/core';
import {AccountService} from "../../services/accountservice/account.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  constructor(public accountService: AccountService) {
  }

  ngOnInit() {
  }

  public logout() {

  }

}
